module.exports = __webpack_public_path__ + "instagram-montage-artistes.png?37d771783bc275b5d82ac7892b828da4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instagram-montage-artistes.png
// module id = 172
// module chunks = 0